import { Button, Dialog, DialogContent, DialogTitle, Link } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { GridOptions } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { AxiosInstance } from "axios";
import { SubscriptionType } from "components/dashboard/executive/cellRenderer/SubscriptionRenderer";
import HealthScoreRenderer from "components/portfolio/cellRenderer/HealthScoreRenderer";
import { Dispatch, SetStateAction } from "react";
import { getContextMenu } from "utils";

const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: "absolute",
    right: 0,
    top: theme.spacing(2),
    color: "grey",
  },
  capitalize: {
    textTransform: "capitalize",
  },
}));

export interface SiteURLsDialogProps {
  siteURLsHandleClose: () => void;
  siteCellData: any;
  siteDialogStatus: boolean;
  type?: string;
  axios?: AxiosInstance;
  accountType?: string;
  subType?: string;
}

const SubscriptionDialog = ({
  list,
  fieldKey,
  dialogStatus,
  setDialogStatus,
}: {
  list: SubscriptionType[];
  fieldKey: string;
  dialogStatus: boolean;
  setDialogStatus: Dispatch<SetStateAction<boolean>>;
}) => {
  const classes = useStyles();

  const rowData: any[] = list;

  const getCellLabel = (fieldKey: string) => {
    if (fieldKey === "lifecycleStageByWorkload") {
      return "Lifecycle Stage by Workload";
    } else if (fieldKey === "forecasting") {
      return "Renewal Forecasting";
    } else if (fieldKey === "renewalFactors") {
      return "Factors Impacting Renewal";
    }
    return "";
  };

  const config: GridOptions = {
    columnDefs: [
      {
        headerName: "Subscription ID",
        field: "subscriptionId",
        colId: "subscriptionId",
        valueGetter: (params) => params?.data?.subscriptionId ?? "N/A",
        pinned: "left",
        minWidth: 200,
        suppressMovable: true,
        lockPinned: true,
        lockPosition: true,
      },
      {
        headerName: getCellLabel(fieldKey),
        colId: fieldKey,
        field: fieldKey,
        valueGetter: (params) => {
          return params.data[fieldKey].join(", ");
        },
        cellStyle: { "border-right-color": "#e2e2e2" },
        flex: 1,
        minWidth: 300,
      },
    ],
    defaultColDef: {
      resizable: true,
      sortable: true,
    },
    tooltipShowDelay: 0,
    rowData,
    getContextMenuItems: getContextMenu,
    suppressRowTransform: true,
    onGridReady: (params) => {
      const gridApi = params.columnApi;
      const allColumnIds: string[] = [];
      gridApi.getAllColumns().forEach((column) => {
        allColumnIds.push(column.getId());
      });
      gridApi.autoSizeColumns(allColumnIds, false);
    },
    onSortChanged(event) {
      const { api } = event;
      const rowModel = api.getSortModel();
      //@ts-ignore
      const data = getSortedData(siteCellData, rowModel?.[0]);
      api.setRowData(data);
    },
    frameworkComponents: {
      HealthScoreRenderer,
    },
  };

  return (
    <>
      <Dialog
        open={dialogStatus}
        onClose={() => setDialogStatus(false)}
        fullWidth={true}
        maxWidth="sm"
      >
        <DialogTitle
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          {"Subscriptions"}
          {fieldKey === "lifecycleStageByWorkload" && (
            <div
              style={{
                position: "absolute",
                right: 70,
                top: 25,
              }}
            >
              <Link
                target="_blank"
                rel="noopener noreferrer"
                href={
                  "https://app.powerbi.com/groups/me/apps/4b9b445f-79c0-4b58-b04b-33a1aae5f68d/reports/783ed656-b961-4b01-9b23-d9e3559c2542/ReportSection39505f477abaea8fcfaf?ctid=5ae1af62-9505-4097-a69a-c1553ef7840e&experience=power-bi&clientSideAuth=0"
                }
              >
                Lifecycle Power BI Report
              </Link>
            </div>
          )}

          <Button
            className={classes.closeButton}
            onClick={() => setDialogStatus(false)}
          >
            x
          </Button>
        </DialogTitle>
        <DialogContent dividers={true}>
          <div
            className="ag-theme-material"
            style={{
              height: "30vh",
              width: "100%",
            }}
          >
            <AgGridReact {...config} />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default SubscriptionDialog;
